import { faArrowRight, faInfoCircle } from '@fortawesome/pro-regular-svg-icons';
import { useRouter } from '@tanstack/react-router';
import type { PartySubscriptionResponse } from '@uturn/api/v1';

import {
	Button,
	Callout,
	CalloutIcon,
	CalloutTitle,
	Icon,
} from '@uturn/ui-kit';
import { useTranslation } from 'react-i18next';

export function RemainingRequestsBanner({
	subscription,
	remainingRequests,
}: {
	subscription: PartySubscriptionResponse;
	remainingRequests: number;
}) {
	const router = useRouter();
	const { t } = useTranslation();
	return (
		<Callout>
			<CalloutIcon>
				<Icon icon={faInfoCircle} />
			</CalloutIcon>
			<CalloutTitle>
				{t(
					'pages.price-calculator.subscription.banner',
					'You have a {{tier}} subscription with {{requestLimit}} requests remaining.',
					{
						tier: subscription.activeSubscription?.tierName ?? '',
						requestLimit: remainingRequests,
					},
				)}
			</CalloutTitle>
			<Button
				size="sm"
				className="ml-auto flex items-center gap-3"
				onClick={() => {
					router.navigate({ to: '/calculator/subscriptions' });
				}}
			>
				{t('pages.price-calculator.subscription.upgrade', 'Upgrade')}
				<Icon icon={faArrowRight} />
			</Button>
		</Callout>
	);
}
